exports = module.exports = require("../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".prometheus-metric-type-selector-account-hint {\n  display: flex;\n  align-items: center;\n  height: 30px;\n}\n", ""]);

